<template>
  <div class="nav">
    <ul>
      <li @click="$parent.goNav('/activity')">
        <a id="gopromo_btn" :class="path == '/activity' ? 'nav-promo cur' : 'nav-promo'"><span>优惠</span></a>
      </li>
      <li @click="$parent.goNav('/kefu')">
        <a id="gohelper_btn" :class="path == '/kefu' ? 'nav-helper cur' : 'nav-helper'"><span>客服</span></a>
      </li>
      <li @click="$parent.goNav('/')">
        <a id="gomainpg_btn " :class="path == '/' ? 'nav-home animated-wobble cur' : 'nav-home animated-wobble'"><span>首页</span></a>
      </li>
      <li @click="$parent.goNav('/zhanzhu')">
        <a id="gosponsor_btn" :class="path == '/zhanzhu' ? 'nav-sponsor cur' : 'nav-sponsor'"><span>赞助</span></a>
      </li>
      <li @click="$parent.goNav('/mine')">
        <a id="gomyprofile_btn" :class="path == '/mine' ? 'nav-my cur' : 'nav-my'"><span>我的</span><i class="news-tip"></i></a>
      </li>
    </ul>
  </div>
</template>
<script>
//
export default {
  name: 'Foot',
  data() {
    return { path: '/' };
  },
  methods: {
    changPath() {
      let that = this;
      let path = this.$route.path;
      that.path = path;

    },
  },
  mounted() {},
  watch: {
    //监听路由地址的改变
    $route: {
      immediate: true,
      handler() {
        let that = this;
        that.changPath();
      },
    },
  },
};
</script>

<style lang="scss" scoped>
// @import '../../../static/css/chunk-611499bd.2ebefcf0.css';
</style>



// WEBPACK FOOTER //
// src/components/libs/Foot.vue